import React from 'react';
import {
  Button, ButtonText, Text, VStack,
} from '@gluestack-ui/themed';
import { useTranslation } from 'react-i18next';
import type { ScheduledChangeDetail } from '@/common/api/models';
import ContentGroup from '@/common/components/ContentGroup';
import { workingModeChangeLines } from '../utils/workingModeChangeLines';

interface Props {
  change: ScheduledChangeDetail;
  onOpenDraft?: (moduleId: string, version: string) => void;
}

export const WorkingModeSwitchReview: React.FC<Props> = ({
  change,
  onOpenDraft,
}) => {
  const { t } = useTranslation();
  const draftVersion = change.workingMode?.draftVersion;
  const showOpenDraft = !!draftVersion && (change.state === 'scheduled' || change.state === 'draft_ready');
  const changeLines = workingModeChangeLines(change.workingMode?.changes, t);

  return (
    <VStack space="md">
      {showOpenDraft && (
        <Button
          action="primary"
          onPress={() => onOpenDraft?.(change.moduleId, draftVersion!)}
          testID="scheduled-change-open-draft"
        >
          <ButtonText>{t('lecturer.scheduledChanges.workingMode.openDraft')}</ButtonText>
        </Button>
      )}
      {changeLines.length > 0 && (
        <ContentGroup variant="subtle" bg="$bgSubtle" px="$3" py="$2.5">
          <VStack space="xs">
            {changeLines.map((line) => (
              <Text key={line} size="sm" color="$textBody">
                {line}
              </Text>
            ))}
          </VStack>
        </ContentGroup>
      )}
    </VStack>
  );
};
